/**
 * Client-side wishlist stored in localStorage. No backend — items are kept
 * as small denormalized records (id, handle, title, image, price, url) so
 * the wishlist page can render without re-fetching product data.
 */
window.Wishlist = (function () {
  var STORAGE_KEY = 'ame-wishlist';

  function readAll() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function writeAll(items) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {
      // Storage unavailable (private mode, quota, etc.) — fail silently.
    }
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { items: items } }));
  }

  function has(id) {
    return readAll().some(function (item) {
      return String(item.id) === String(id);
    });
  }

  function add(item) {
    var items = readAll();
    if (!items.some(function (i) { return String(i.id) === String(item.id); })) {
      items.push(item);
      writeAll(items);
    }
  }

  function remove(id) {
    writeAll(readAll().filter(function (item) {
      return String(item.id) !== String(id);
    }));
  }

  function toggle(item) {
    if (has(item.id)) {
      remove(item.id);
      return false;
    }
    add(item);
    return true;
  }

  function count() {
    return readAll().length;
  }

  function bindToggleButtons(root) {
    (root || document).querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      if (btn.dataset.wishlistBound) return;
      btn.dataset.wishlistBound = 'true';

      var id = btn.getAttribute('data-product-id');

      function sync() {
        var active = has(id);
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      }

      sync();
      document.addEventListener('wishlist:change', sync);

      btn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        toggle({
          id: id,
          handle: btn.getAttribute('data-product-handle'),
          title: btn.getAttribute('data-product-title'),
          image: btn.getAttribute('data-product-image'),
          price: btn.getAttribute('data-product-price'),
          variantId: btn.getAttribute('data-product-variant-id'),
          url: btn.getAttribute('data-product-url')
        });
        sync();
      });
    });
  }

  function bindCountBadges(root) {
    (root || document).querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      function sync() {
        var n = count();
        el.textContent = n;
        el.hidden = n === 0;
      }
      sync();
      document.addEventListener('wishlist:change', sync);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    bindToggleButtons(document);
    bindCountBadges(document);
  });

  return {
    readAll: readAll,
    has: has,
    add: add,
    remove: remove,
    toggle: toggle,
    count: count,
    bindToggleButtons: bindToggleButtons,
    bindCountBadges: bindCountBadges
  };
})();
